(function () {
  'use strict';

  /* ── Reading Progress Bar ── */
  var progressBar = document.getElementById('pnh-art-progress');
  var article     = document.querySelector('.pnh-art__content');

  function updateProgress() {
    if (!progressBar || !article) return;
    var rect   = article.getBoundingClientRect();
    var total  = rect.height - window.innerHeight;
    var scrolled = Math.max(0, -rect.top);
    var pct    = total > 0 ? Math.min(1, scrolled / total) : 0;
    progressBar.style.transform = 'scaleX(' + pct + ')';
  }

  var _artTicking = false;
  window.addEventListener('scroll', function () {
    if (!_artTicking) {
      window.requestAnimationFrame(function () { updateProgress(); _artTicking = false; });
      _artTicking = true;
    }
  }, { passive: true });
  updateProgress();

  /* ── Reading Time ── */
  var readTimeEl = document.querySelector('.pnh-art__read-time-val');
  if (readTimeEl && article) {
    var words   = article.textContent.trim().split(/\s+/).length;
    var minutes = Math.max(1, Math.round(words / 200));
    readTimeEl.textContent = minutes + ' min read';
  }

  /* ── Table of Contents ── */
  var tocList = document.getElementById('pnh-art-toc-list');
  if (tocList && article) {
    var headings = article.querySelectorAll('h2');
    if (headings.length > 0) {
      headings.forEach(function (h, i) {
        var id = h.id || ('pnh-section-' + i);
        h.id = id;

        var li = document.createElement('li');
        li.className = 'pnh-art__toc-item';

        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent.replace(/^\d+\.\s*/, '');
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.getElementById(id);
          if (target) {
            var offset = 80;
            var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        });

        li.appendChild(a);
        tocList.appendChild(li);
      });

      /* Scroll spy */
      var tocItems = tocList.querySelectorAll('.pnh-art__toc-item');

      function updateTOC() {
        var scrollY = window.pageYOffset + 120;
        var active  = -1;

        headings.forEach(function (h, i) {
          if (h.offsetTop <= scrollY) active = i;
        });

        tocItems.forEach(function (item, i) {
          item.classList.toggle('is-active', i === active);
        });
      }

      window.addEventListener('scroll', updateTOC, { passive: true });
      updateTOC();
    } else {
      var tocWrapper = document.querySelector('.pnh-art__toc');
      if (tocWrapper) tocWrapper.style.display = 'none';
    }
  }

  /* ── Scroll Reveal ── */
  if ('IntersectionObserver' in window) {
    var revealEls = document.querySelectorAll(
      '.pnh-art__author, .pnh-art__products, .pnh-art__rel-card'
    );

    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealIO.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -32px 0px' });

    revealEls.forEach(function (el, i) {
      el.style.transitionDelay = (i * 0.06) + 's';
      revealIO.observe(el);
    });
  }

  /* ── Share Buttons ── */
  var shareUrl   = encodeURIComponent(window.location.href);
  var shareTitle = encodeURIComponent(document.title);

  var twitterBtn  = document.getElementById('pnh-share-twitter');
  var facebookBtn = document.getElementById('pnh-share-facebook');
  var copyBtn     = document.getElementById('pnh-share-copy');

  if (twitterBtn) {
    twitterBtn.href = 'https://twitter.com/intent/tweet?url=' + shareUrl + '&text=' + shareTitle;
    twitterBtn.target = '_blank';
    twitterBtn.rel = 'noopener noreferrer';
  }

  if (facebookBtn) {
    facebookBtn.href = 'https://www.facebook.com/sharer/sharer.php?u=' + shareUrl;
    facebookBtn.target = '_blank';
    facebookBtn.rel = 'noopener noreferrer';
  }

  if (copyBtn) {
    copyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          showCopied(copyBtn);
        }).catch(function () {
          fallbackCopy(url);
        });
      } else {
        fallbackCopy(url);
      }
    });
  }

  function fallbackCopy(url) {
    try {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      showCopied(copyBtn);
    } catch (err) {}
  }

  function showCopied(btn) {
    var original = btn.innerHTML;
    btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 7l3.5 3.5L12 3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg> Copied!';
    setTimeout(function () { btn.innerHTML = original; }, 2000);
  }

}());
